import { theme } from 'configs/styled';
import React from 'react';
import Divider from '../components/Divider';
import DriverPortalLayout from '../components/DriverPortalLayout';
import HeaderPortal from '../components/HeaderPortal';
import MessageDisplay from '../components/MessageDisplay';
import TextBold from '../components/TextBold';
import TextRegular from '../components/TextRegular';
import Title from '../components/Title';
import BulletList from '../MainPage/components/BulletList';

export interface ITermsAndConditionProps {}

const NewTermsAndCondition: React.FC<ITermsAndConditionProps> = () => {
  return (
    <>
      <HeaderPortal />
      <DriverPortalLayout>
        <Title>ข้อตกลงและเงื่อนไขการใช้งานเว็บไซต์</Title>
        <div>
          <MessageDisplay title="">
            <TextRegular color={theme.palettes.black85}>
              เว็บไซต์นี้ บริษัท ออลล์ นาว แมนเนจเม้นท์ จำกัด และ บริษัท ออลล์
              นาว โลจิสติกส์ จำกัด (ซึ่งต่อไปนี้จะเรียกรวมกันว่า{' '}
              <TextBold color={theme.palettes.black85}>“บริษัท”</TextBold>)
              เป็นเจ้าของและเป็นผู้ควบคุมการใช้งานเว็บไซต์ โดยผู้ใช้งาน
              (ซึ่งต่อไปนี้จะเรียกว่า{' '}
              <TextBold color={theme.palettes.black85}>“ท่าน”</TextBold>)
              ได้อ่านข้อตกลงและเงื่อนไขการใช้งานเว็บไซต์ (ซึ่งต่อไปนี้จะเรียกว่า{' '}
              <TextBold color={theme.palettes.black85}>“ข้อตกลง”</TextBold>)
              และตกลงยินยอมปฏิบัติตามเงื่อนไขการใช้งานที่กำหนดไว้ภายใต้ข้อตกลงต่อไปนี้
              และกฎหมายที่บังคับใช้ทั้งหมดที่เกี่ยวข้อง ข้อตกลงนี้บังคับใช้กับ
              https://reg.allnowgroup.com/signup (
              <TextBold color={theme.palettes.black85}>“เว็บไซต์”</TextBold>)
              โดยการใช้งานเว็บไซต์นี้
              ไม่ว่าจะปรากฏในแอปพลิเคชันหรืออุปกรณ์รูปแบบใดก็ตาม
              ท่านตกลงที่จะผูกพันทางกฎหมายกับบริษัท
              บริษัทขอสงวนสิทธิ์ในการเปลี่ยนแปลงข้อตกลงเหล่านี้ได้ตลอดเวลา
              บริษัทขอแนะนำให้ท่านตรวจสอบเว็บไซต์เป็นประจำเพื่อรับข้อมูลล่าสุดเกี่ยวกับข้อตกลงเหล่านี้
              หากท่านตกลงยินยอมที่จะผูกพันตามข้อตกลงเหล่านี้
              ท่านจะสามารถใช้งานเว็บไซต์ได้
            </TextRegular>
          </MessageDisplay>
          <MessageDisplay title="1. ข้อตกลงทั่วไป">
            การเข้าถึงและการใช้งานเว็บไซต์นี้
            ท่านได้ทำการยอมรับโดยปราศจากเงื่อนไขในข้อตกลง
            ซึ่งบริษัทขอสงวนสิทธิ์ใช้
            ดุลยพินิจของบริษัทแต่เพียงผู้เดียวในการปรับปรุงหรือแก้ไขข้อตกลงนี้
            การใช้งานเว็บไซต์อย่างต่อเนื่องหลังจากการประกาศการเปลี่ยนแปลงเกี่ยวกับข้อตกลง
            ให้ถือว่าท่านยอมรับการเปลี่ยนแปลงเหล่านั้น
            <br />
            <br />
            ท่านรับประกันและรับรองว่าท่านมีอายุครบ 20 ปีบริบูรณ์
            หรือหากท่านอายุน้อยกว่า 20 ปีบริบูรณ์ ซึ่งบิดามารดา
            หรือผู้ปกครองได้ให้ความยินยอมแล้ว ท่านมีสิทธิตามกฎหมาย
            มีความสามารถอย่างเต็มที่ในการเข้าทำสัญญาและปฏิบัติตามข้อตกลง
            เงื่อนไข ภาระผูกพัน การยืนยัน การรับรอง
            และการรับประกันที่กำหนดไว้ในข้อตกลงนี้
          </MessageDisplay>
          <MessageDisplay title="2. การสมัครสมาชิก">
            <TextRegular color={theme.palettes.black85} margin="15px">
              2.1 ในการสมัครสมาชิกนั้น ให้ใช้งานได้เพียงผู้ใช้งานเดียวเท่านั้น
              (ซึ่งต่อไปนี้จะเรียกรวมกันว่า{' '}
              <TextBold color={theme.palettes.black85}>“สมาชิก”</TextBold>)
              ท่านจะต้องระบุ จังหวัด, ประเภทรถ, ชื่อ-นามสกุล,
              เลขบัตรประจำตัวประชาชน, หมายเลขโทรศัพท์มือถือ และรหัสแนะนำคนขับ
              รวมถึงข้อมูลอื่น ๆ หากบริษัทร้องขอ ในการนี้
              ห้ามมิให้ผู้อื่นใช้งานสมาชิกของท่าน
              ในกรณีที่มีการใช้สมาชิกไม่เหมาะสมหรือไม่ได้รับอนุญาต
              บริษัทขอสงวนสิทธิ์ที่จะยกเลิก จำกัด หรือระงับ
              การเป็นสมาชิกและ/หรือการเข้าถึงเว็บไซต์ของท่านได้ตลอดเวลาตามที่บริษัทเห็นสมควรหรือจำเป็น
              โดยบริษัทไม่ต้องรับผิดชอบใด ๆ นอกจากนี้
              บริษัทสงวนสิทธิ์ในการยกเลิก จำกัด หรือระงับสมาชิก
              หากเห็นว่าท่านพยายามกระทำการใด ๆ
              ให้เกิดผลในการปิดบังซ่อนเร้นการใช้งานหลายบัญชีหรือกระทำใด ๆ
              อันเป็นการขัดขวางการดำเนินการใดของบริษัท
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              2.2 ในการสมัครสมาชิกของท่านนั้น
              ท่านรับรองและรับประกันว่าข้อมูลในการสมัครสมาชิกทั้งหมดที่ท่านให้แก่บริษัท
              ถูกต้องตามกฎหมาย ครบถ้วน เชื่อถือได้ และเป็นข้อมูลปัจจุบัน
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              2.3
              ท่านมีหน้าที่รับผิดชอบแต่เพียงผู้เดียวต่อการกระทำทั้งหมดที่เกิดขึ้นจากการเป็นสมาชิกของท่าน
              สำหรับการใช้งานเว็บไซต์ทั้งหมดโดยท่านหรือบุคคลอื่นใดก็ตามที่ใช้สมาชิกของท่าน
              ไม่ว่าจะได้รับอนุญาตจากท่านหรือไม่ก็ตาม ทั้งนี้
              เพื่อป้องกันการใช้สมาชิกของท่านซึ่งไม่ได้รับอนุญาต รักษาความลับ
              และความปลอดภัยข้อมูลจากการเป็นสมาชิกของท่าน
              ท่านตกลงที่จะไม่เปิดเผยข้อมูลการเป็นสมาชิก รหัสยืนยันตัวตน
              และ/หรือรหัสผ่านของท่านต่อบุคคลอื่น โดยแจ้งให้บริษัททราบทันที
              หากท่านเชื่อว่ามีการละเมิดข้อมูลของท่าน เช่น การเปิดเผยข้อมูล
              การโจรกรรมหรือการใช้สมาชิกของท่านโดยไม่ได้รับอนุญาต เป็นต้น
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              2.4 ท่านจะต้องไม่โอนสมาชิกให้กับบุคคลอื่น
              ไม่ว่าท่านจะได้รับค่าตอบแทนเพื่อการนั้นหรือไม่ก็ตาม
            </TextRegular>
          </MessageDisplay>
          <MessageDisplay title="3. การใช้งานเว็บไซต์">
            <TextRegular color={theme.palettes.black85} margin="15px">
              3.1 ในกรณีที่ท่านสมัครสมาชิกหลายครั้ง
              บริษัทจะเก็บข้อมูลจากการสมัครสมาชิกล่าสุดเท่านั้น
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              3.2 ท่านยอมรับว่าข้อมูล บันทึก หลักฐานหรือเอกสารใด ๆ ก็ตาม
              ที่บริษัทได้จัดทำขึ้น
              อันเนื่องมาจากการใช้งานเว็บไซต์ของท่านนั้นจะมีความถูกต้องทุกประการ
              โดยไม่จำเป็นต้องให้ท่านตรวจสอบหรือให้ความยินยอมก่อนแต่อย่างใด
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              3.3 ท่านตกลงยินยอมผูกพันและตกลงปฏิบัติตามคู่มือ ระเบียบ
              วิธีปฏิบัติของบริษัท และเอกสารใด ๆ
              ที่เกี่ยวข้องกับการใช้งานเว็บไซต์
              ซึ่งบริษัทได้มอบหรือส่งให้แก่ท่าน ทั้งที่มีอยู่ ณ
              ขณะนี้และที่บริษัทจะเพิ่มเติมต่อไปในอนาคต นอกจากนี้ คู่มือ ระเบียบ
              วิธีปฏิบัติ และเอกสารใด ๆ เกี่ยวกับการใช้งานเว็บไซต์
              ที่บริษัทจะประกาศเพิ่มเติมในอนาคต
              ให้ถือว่าเป็นส่วนหนึ่งของข้อตกลงนี้ด้วย
              รวมทั้งท่านยินยอมปฏิบัติตามคู่มือ ระเบียบ และวิธีปฏิบัติของบริษัท
              และ/หรือข้อกำหนดตามกฎหมายที่เกี่ยวข้อง
              รวมทั้งจัดทำเอกสารอื่นใดให้แก่บริษัทตามที่บริษัทและ/หรือทางราชการเป็นผู้กำหนดด้วย
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              3.4 ธุรกรรมใดที่ท่านได้กระทำล่วงหน้าก่อนสมาชิกจะถูกยกเลิก จำกัด
              หรือระงับ
              ท่านตกลงให้ถือว่าธุรกรรมดังกล่าวยังคงมีผลใช้ผูกพันท่านอยู่
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              3.5 ท่านจะไม่กระทำการใด ๆ
              อันมีผลให้บริษัทมีส่วนร่วมในข้อพิพาทระหว่างท่านกับบุคคลอื่นใด
              ซึ่งเกี่ยวเนื่องจากการใช้งานเว็บไซต์ตามข้อตกลงนี้
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              3.6
              ในกรณีที่ท่านใช้งานเว็บไซต์แล้วเกิดความบกพร่องผิดพลาดจากการใช้งานเว็บไซต์
              ไม่ว่าความบกพร่องผิดพลาดนั้น ๆ จะเกิดขึ้นด้วยเหตุผลประการใด ๆ
              ท่านตกลงยินยอมให้บริษัทมีอำนาจแก้ไขความบกพร่องผิดพลาดให้ถูกต้อง
              โดยไม่ต้องแจ้งหรือขออนุญาตจากท่านก่อนล่วงหน้า อนึ่ง
              ท่านยินยอมให้ถือว่าบรรดาเอกสารต่าง ๆ ที่เกี่ยวกับการใช้งานเว็บไซต์
              ซึ่งเป็นเอกสารที่บริษัทจัดทำขึ้นเพื่อการแก้ไขความบกพร่องผิดพลาดข้างต้น
              เป็นเอกสารที่มีความถูกต้องสมบูรณ์ครบถ้วนและมีผูกพันท่านทุกประการโดยไม่จำเป็นต้องให้ท่านตรวจสอบหรือให้ความยินยอมก่อนแต่อย่างใด
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              3.7 กรณีท่านพบความบกพร่องผิดพลาดใด ๆ จากการใช้งานเว็บไซต์
              ท่านจะต้องแจ้งรายละเอียดข้อมูลเกี่ยวกับ วัน เวลาที่ทำ รายการ ชื่อ
              และสถานที่ติดต่อของท่านให้บริษัททราบทันที
              โดยท่านยินยอมให้บริษัทดำเนินการตรวจสอบความบกพร่องผิดพลาดจากข้อมูลที่ได้รับจากท่าน
              ตามวิธีการที่บริษัทกำหนด
              หากปรากฏในภายหลังว่าความบกพร่องผิดพลาดดังกล่าว
              เกิดจากการกระทำของท่านเอง
              และบริษัทได้ดำเนินการไปตามข้อมูลที่ท่านแจ้งแล้ว
              ท่านตกลงสละสิทธิ์ในการเรียกร้องหรือฟ้องร้องต่อบริษัท
              รวมทั้งเรียกร้องค่าเสียหายใด ๆ อีกด้วย นอกจากนี้
              หากบริษัทต้องชดใช้ค่าใช้จ่าย หรือค่าเสียหายใด ๆ
              ให้แก่บุคคลอื่นเนื่องจากความผิดพลาดข้างต้นแล้ว
              ท่านตกลงจะชดใช้เงินจำนวนดังกล่าวพร้อมดอกเบี้ย
              คืนให้แก่บริษัทจนกว่าจะครบถ้วนเต็มจำนวน
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              3.8 ท่านตกลงและรับทราบว่าบริษัทมีสิทธิติดต่อสอบถาม สืบค้น
              ตรวจสอบสถานภาพ
              ข้อมูลรายละเอียดบางประการหรือทั้งหมดของท่านจากหน่วยงานราชการ (เช่น
              สถาบันการเงิน กรมสรรพากร กรมพัฒนาธุรกิจการค้า หรือกรมการปกครอง
              เป็นต้น)
              ในกรณีที่จำเป็นเปิดเผยข้อมูลรายละเอียดบางประการหรือทั้งหมดของท่านให้แก่หน่วยงานราชการที่มีอำนาจตามกฎหมาย
              หรือเป็นการดำเนินการตามที่กฎหมายกำหนด
              และบริษัทมีสิทธิใช้ข้อมูลนี้ในการแก้ไข ปรับปรุง
              เพิ่มเติมข้อมูลเดิมของบริษัทให้ถูกต้อง ครบถ้วน เป็นปัจจุบัน
              โดยไม่จำเป็นต้องให้ท่านตรวจสอบหรือให้ความยินยอมก่อนแต่อย่างใด
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              3.9 ท่านตกลงนำส่งเอกสาร ข้อมูล
              และ/หรือรายละเอียดตามที่กำหนดในเว็บไซต์ให้ถูกต้อง ครบถ้วน
              และภายในระยะเวลาที่บริษัทกำหนด และท่านรับรองว่าบรรดาเอกสาร ข้อมูล
              รายละเอียดใดๆ ที่ปรากฏบนเว็บไซต์ และ/หรือ
              ที่ได้ส่งมาให้บริษัทไม่ว่าจะส่งมาในรูปแบบใด
              มีความครบถ้วนและถูกต้องแท้จริง
              และในกรณีที่ท่านเข้าใช้งานเว็บไซต์และส่งเอกสาร ข้อมูล
              และ/หรือรายละเอียดใด ๆ ที่ไม่ถูกต้องครบถ้วน ผิดพลาด บกพร่อง ล่าช้า
              หรือมีข้อบกพร่องหรือข้อผิดพลาดใดๆ
              เกิดขึ้นจากการที่บริษัทได้ดำเนินการตามเอกสาร ข้อมูล
              และ/หรือรายละเอียดดังกล่าวไม่ว่าด้วยเหตุใดก็ตาม
              บริษัทไม่ต้องรับผิดชอบไม่ว่ากรณีใด ๆ ทั้งนี้
              ท่านตกลงสละสิทธิ์ในการเรียกร้องหรือฟ้องร้องให้บริษัทชดใช้หรือดำเนินการใด
              ๆ ต่อท่านหรือบุคคลภายนอก ไม่ว่าจะมีชื่อปรากฏในเอกสาร ข้อมูล
              และ/หรือรายละเอียดที่ท่านได้ส่งให้แก่บริษัทหรือไม่ก็ตาม
              และไม่ว่าในรูปแบบใด อีกทั้งท่านขอรับรองว่าจะไม่กระทำการใด ๆ
              อันมีผลให้บริษัทต้องมีส่วนร่วมในข้อพิพาทระหว่างท่านกับบุคคลอื่น
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              3.10 หากเอกสาร หลักฐาน และ/หรือรายละเอียดใด ๆ
              ที่ท่านได้ส่งมาให้กับบริษัท ไม่ว่าจะส่งมอบในรูปแบบใด
              มีความไม่ถูกต้อง ครบถ้วน ผิดพลาด หรือบกพร่อง
              ท่านจะต้องแก้ไขข้อมูลที่บกพร่องนั้นให้ถูกต้อง ครบถ้วน
              โดยท่านอาจแก้ไขข้อมูลด้วยตัวเองหรือแจ้งให้บริษัทแก้ไขข้อมูลที่บกพร่องนั้น
              และหากท่านแจ้งแก้ไขข้อมูลที่บกพร่องให้แก่บริษัททราบภายหลังจากที่บริษัทได้อนุมัตินำข้อมูลเข้าเว็บไซต์และใช้งานข้อมูลดังกล่าวแล้ว
              บริษัทสงวนสิทธิ์ในการแก้ไขข้อมูลดังกล่าวให้แก่ท่านโดยไม่ต้องขอความยินยอมได้
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              3.11 ในกรณีที่บริษัทร้องขอให้ท่านส่งมอบข้อมูลเกี่ยวกับใบอนุญาต
              เอกสารราชการ การอนุมัติ ความยินยอม กรมธรรม์ประกันภัย คำรับรอง
              หน้าบัญชีธนาคาร
              และท่านได้ส่งมอบข้อมูลดังกล่าวให้แก่บริษัทผ่านเว็บไซต์แล้ว
              ให้ถือว่าท่านเป็นผู้มีสิทธิและหน้าที่ภายในขอบเขตของกฎหมายที่เกี่ยวข้อง
              หากมีความเสียหายเกิดขึ้นจากการไม่ดำเนินการขอหรือต่ออายุใบอนุญาต
              เอกสารราชการ การอนุมัติ ความยินยอม กรมธรรม์ประกันภัย คำรับรอง
              หรือจัดทำบัญชีธนาคาร ตามที่บริษัทกำหนด
              ท่านมีหน้าที่ต้องรับชอบต่อความเสียหายที่เกิดขึ้นเต็มจำนวนโดยไม่คำนึงว่าใบอนุญาต
              เอกสารราชการ การอนุมัติ ความยินยอม กรมธรรม์ประกันภัย คำรับรอง
              หรือหน้าบัญชีธนาคาร
              ที่ท่านได้ส่งมอบให้แก่บริษัทจะมีผลใช้บังคับหรือไม่ก็ตาม
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              3.12 บริษัทอาจร้องขอให้ท่านแก้ไข ลบ หรือยุติการส่งมอบข้อมูล
              ของท่านผ่านทางเว็บไซต์ ซึ่งบริษัทพิจารณาเห็นว่า ไม่ได้รับอนุญาต
              ทำให้เกิดการเข้าใจผิด น่ารังเกียจ ถูกคุกคาม หมิ่นประมาท ผิดกฎหมาย
              ไม่เหมาะสม หรือขัดแย้งต่อข้อตกลงนี้
              หากท่านไม่กระทำการตามข้อเรียกร้องของบริษัท
              บริษัทสงวนสิทธิ์ในการแก้ไข ลบ หรือตัดการเชื่อมต่อเนื้อหา
              หรือการติดต่อสื่อสารนั้น ๆ
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              3.13
              ท่านจะกลั่นกรองและตรวจสอบเนื้อหาทั้งหมดที่ส่งมอบข้อมูลบนเว็บไซต์อย่างละเอียดและรอบคอบ
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              3.14 ท่านจะไม่แก้ไขและตัดต่อรูปภาพ เนื้อหา
              โดยจะอัพโหลดข้อมูลให้บริษัทเห็นข้อมูลครบถ้วน
            </TextRegular>
          </MessageDisplay>
          <MessageDisplay title="4.	ข้อห้ามในการใช้เว็บไซต์">
            <TextRegular color={theme.palettes.black85}>
              ในการใช้งานเว็บไซต์ ท่านตกลงจะไม่ดำเนินการใด ๆ ดังต่อไปนี้
              โดยบริษัทมีสิทธิระงับหรือยกเลิกสมาชิกของท่านได้ทันที
              และไม่ต้องรับผิดชอบใด ๆ ในบรรดาความเสียหายที่เกิดขึ้นต่อท่าน
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              4.1 การใช้งานเว็บไซต์นี้เพื่อวัตถุประสงค์ใด ๆ
              ที่ผิดกฎหมายหรือต้องห้ามตามข้อตกลง
              หรือจูงใจให้บุคคลอื่นใช้เว็บไซต์โดยผิดกฎหมาย
              โดยไม่คำนึงถึงสิทธิอื่นใดหรือข้อจำกัดในข้อตกลงนี้
              ท่านไม่ได้รับอนุญาตให้ใช้งานเว็บไซต์นี้เพื่อส่งต่อโดยตรงหรือผ่านเว็บไซต์ซึ่งข้อมูล
              ข้อความ เนื้อความ รูปภาพ ไฟล์ ลิงค์หรือซอฟต์แวร์
              ยกเว้นการเชื่อมต่อของท่านที่ได้รับอนุญาตจากบริษัทในการใช้งานเว็บไซต์
              รวมถึงการเข้าสู่เว็บไซต์หรือคอมพิวเตอร์อื่น ๆ
              รวมถึงการเข้าสู่เว็บไซต์ที่มีความเสี่ยงด้านความปลอดภัย
              และ/หรือรหัสที่เป็นอันตราย และกิจกรรมซึ่งเป็นการฉ้อโกง พนัน
              การรวบรวมหรือเก็บเกี่ยวข้อมูลเกี่ยวกับผู้ใช้งานรายอื่นบนเว็บไซต์ของบริษัทไม่ว่าด้วยเหตุผลใดก็ตาม
              รวมถึงแต่ไม่จำกัดเฉพาะการส่งอีเมลเพื่อการค้าที่ไม่พึงประสงค์ให้แก่บุคคลภายนอก
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              4.2 ต้องไม่ส่งสแปมหรือส่งข้อความซ้ำ ๆ
              หรือข้อความอันไม่พึงประสงค์เข้าสู่เว็บไซต์
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              4.3 ต้องไม่ส่งเนื้อหาที่เป็นการละเมิด ลามก อนาจาร ข่มขู่ ใส่ร้าย
              หรือเนื้อหาอื่นใดที่ผิดกฎหมาย
              ขัดต่อความสงบเรียบร้อยหรือศีลธรรมอันดีของประชาชน หรือเป็นการละเมิด
              รวมถึงแต่ไม่จำกัดเฉพาะสื่อที่เป็นอันตรายต่อเด็ก ละเมิดสิทธิใด ๆ
              ของบุคคลภายนอก
              หรือที่เป็นอันฝ่าฝืนต่อกฎหมายที่มีผลบังคับใช้และ/หรือนโยบายของบริษัท
              เช่น เนื้อหาที่ไม่เหมาะสมและละเอียดอ่อน
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              4.4
              ต้องไม่แทรกแซงหรือขัดขวางความสมบูรณ์หรือประสิทธิภาพหรือส่วนประกอบใด
              ๆ ของเว็บไซต์นี้หรือข้อมูลที่อยู่ในนั้น
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              4.5 ต้องไม่พยายามเข้าถึงเว็บไซต์หรือซอฟต์แวร์ ระบบ
              หรือเครือข่ายที่เกี่ยวข้องโดยไม่ได้รับอนุญาต
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              4.6 ต้องไม่แอบอ้างเป็นบุคคลอื่น หรือบิดเบือนความจริง เช่น
              การใช้อีเมลเท็จ, การปลอมตัวเป็นบุคคลอื่น, การใช้สมาชิกของผู้อื่น
              เป็นต้น
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              4.7 ต้องไม่มีส่วนร่วมในการกระทำใด ๆ ที่ก่อ
              หรืออาจก่อสร้างความเสียหายต่อชื่อเสียงหรือไม่น่าไว้วางใจต่อบริษัท
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              4.8 ต้องไม่ใช้โปรแกรมหรือสคริปต์แบบแมนนวลหรือแบบอัตโนมัติ
              ซึ่งรวมถึงแต่ไม่จำกัดเพียงโปรแกรมรวบรวมข้อมูลเว็บ เว็บหุ่นยนต์ บอต
              ไวรัส หรือโปรแกรมใด ๆ
              ที่อาจส่งคำขอไปยังเซิร์ฟเวอร์เพื่อเป็นภาระหรือขัดขวางการดำเนินการและ/หรือประสิทธิภาพของเว็บไซต์อย่างไม่เหมาะสม
              หรือเพื่อหลีกเลี่ยงโครงสร้างการนำทางหรือการนำเสนอของเว็บไซต์หรือเนื้อหาของเว็บไซต์
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              4.9
              ต้องไม่ใช้ประโยชน์จากอุปกรณ์หรือเว็บไซต์ที่มีการดัดแปลงด้วยวัตถุประสงค์ในการหลบเลี่ยงการตรวจจับหรือเพื่ออำนวยความสะดวกในการกระทำใด
              ๆ ที่มุ่งหมายเพื่อกระทำการทุจริตต่อบริษัท
              หรือหลีกเลี่ยงการใช้งานที่เหมาะสมของเว็บไซต์และเครือข่ายที่บริการดำเนินการอยู่
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              4.10 ต้องไม่คัดลอก ปรับเปลี่ยน
              สร้างงานเลียนแบบหรือทำวิศวกรรมย้อนกลับ สร้างโปรแกรมแปลกลับ แปล
              แยกส่วน
              หรือกระทำการอื่นใดโดยมีวัตถุประสงค์เพื่อให้ได้มาซึ่งรหัสต้นฉบับ
              (Source Code) ของเว็บไซต์
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              4.11 ต้องไม่เชื่อมต่อเว็บไซต์ไปยังเว็บไซต์ ซอฟต์แวร์
              แพลตฟอร์มหรืออุปกรณ์อื่นใดหรือส่วนใดส่วนหนึ่งของเว็บไซต์ ซอฟต์แวร์
              แพลตฟอร์มหรืออุปกรณ์อื่นใดโดยไม่ได้รับอนุญาตจากบริษัท
              โดยไม่คำนึงถึงข้อกำหนดอื่นใดของเว็บไซต์ ซอฟต์แวร์
              แพลตฟอร์มหรืออุปกรณ์อื่นใดที่เชื่อมโยงไปนั้น
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              4.12
              ต้องไม่ใช้เว็บไซต์นี้ในการส่งผ่านอีเมลเชิงพาณิชย์ที่ไม่ได้รับอนุญาต
              อีเมลขยะ หรือเจตนาส่งเอกสารแนบที่มีขนาดใหญ่ให้แก่บริษัท
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              4.13
              ต้องไม่บุกรุกความเป็นส่วนตัวหรือละเมิดสิทธิบุคคลหรือกรรมสิทธิ์ใด ๆ
              (รวมถึงสิทธิในทรัพย์สินทางปัญญา) ของบริษัท บุคคล หรือนิติบุคคลอื่น
            </TextRegular>
          </MessageDisplay>
          <MessageDisplay title="5.	ทรัพย์สินทางปัญญา">
            <TextRegular color={theme.palettes.black85} margin="15px">
              5.1 สิทธิในทรัพย์สินทางปัญญาทั้งหมด (รวมถึงแต่ไม่จำกัดแค่เพียง
              ลิขสิทธิ์ สิทธิบัตร และเครื่องหมายการค้า)
              ในเนื้อหาทั้งหมดที่แสดงหรือมีอยู่ในเว็บไซต์นี้เป็นของบริษัท
              เว้นแต่ได้มีการระบุไว้เป็นอย่างอื่น หากเจ้าของเนื้อหาใด ๆ
              ที่เผยแพร่บนเว็บไซต์นี้ไม่ใช่บริษัท
              สิทธิของท่านในส่วนที่เกี่ยวข้องกับเนื้อหานั้น
              จะเป็นไปตามที่ได้กำหนดโดยเจ้าของสิทธิของเนื้อหาที่เกี่ยวข้อง
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              5.2 หากมิได้มีการกำหนดไว้เป็นอย่างอื่น
              ท่านไม่ได้รับอนุญาตให้คัดลอกข้อความที่เผยแพร่บนเว็บไซต์โดยบริษัท
              ไม่ว่าเป็นการใช้งานโดยส่วนตัวหรือเชิงพาณิชย์ก็ตาม
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              5.3 ยกเว้นตามที่ได้กำหนดไว้ข้างต้น สิทธิทั้งหมดในเว็บไซต์
              (รวมถึงสิทธิในข้อความ กราฟฟิก การเลือก การจัดเรียง
              และการออกแบบเว็บไซต์โดยรวม) นั้นถูกสงวนไว้
              และไม่ถือว่าเป็นการให้สิทธิหรืออนุญาตใด ๆ ภายใต้ลิขสิทธิ์
              สิทธิบัตร เครื่องหมายการค้า หรือทรัพย์สินทางปัญญาอื่น ๆ
              ของบริษัทหรือบุคคลอื่นใดอันเป็นผลมาจากการเผยแพร่เนื้อหาใด ๆ
              ในเว็บไซต์นี้ ห้ามมิให้ทำซ้ำ ดัดแปลง หรือเผยแพร่
              เนื้อหาจากเว็บไซต์นี้
              ทั้งหมดหรือบางส่วนโดยไม่ได้รับอนุญาตเป็นลายลักษณ์อักษรจากบริษัท
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              5.4 เว้นแต่จะได้รับอนุญาตเป็นลายลักษณ์อักษรจากบริษัท การเข้าถึง
              หรือความพยายามเพื่อให้เข้าถึงพื้นที่อื่นของระบบคอมพิวเตอร์ของบริษัท
              หรือข้อมูลอื่น ๆ ที่มีอยู่ในระบบ เพื่อวัตถุประสงค์ใด ๆ
              นั้นเป็นสิ่งที่ต้องห้ามโดยเด็ดขาด โดยท่านตกลงว่าจะไม่ใช้หุ่นยนต์
              สไปเดอร์ วิธีการอัตโนมัติอื่น ๆ หรือกระทำการด้วยวิธีอื่นใด
              หรือใช้อุปกรณ์ใด ๆ เพื่อคัดลอกหน้าจอ ทำเหมืองข้อมูล
              หรือคัดลอกหน้าเว็บบนเว็บไซต์
              หรือเนื้อหาที่อยู่ภายในเว็บไซต์ดังกล่าว
              โดยไม่ได้รับอนุญาตเป็นลายลักษณ์อักษรจากบริษั
            </TextRegular>
          </MessageDisplay>
          <MessageDisplay title="6.	ข้อยกเว้นความรับผิดของบริษัท">
            <TextRegular color={theme.palettes.black85} margin="15px">
              6.1 บริษัทไม่รับรองและรับประกันใด ๆ ในเนื้อหา
              และข้อมูลที่ปรากฏบนเว็บไซต์นี้ไม่ว่าโดยชัดแจ้งหรือโดยปริยายที่เกี่ยวข้องกับความถูกต้องหรือความสมบูรณ์ของข้อมูลดังกล่าว
              หรือเนื้อหาใดที่มีการอ้างถึงในเว็บไซต์นี้
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              6.2 ลิงค์ในเว็บไซต์นี้อาจนำไปสู่เว็บไซต์อื่น
              และข้อมูลบางส่วนบนเว็บไซต์นี้อาจถูกจัดทำขึ้นโดยบุคคลภายนอก
              โดยบริษัทจะไม่รับรองต่อความถูกต้องของข้อมูลดังกล่าว
              ซึ่งท่านควรตรวจสอบข้อมูลดังกล่าวจากบุคคลภายนอกเหล่านั้นโดยตรง
              โดยการผนวกลิงค์ใด ๆ บนเว็บไซต์นี้ไปยังเว็บไซต์อื่น
              หรือการอ้างอิงใด ๆ ถึงเนื้อหา โดยปรากฏชื่อทางการค้า
              เครื่องหมายการค้า หรืออื่นใดนั้น
              ไม่ได้ถือหรือแสดงนัยว่าได้รับการรับรองหรือแนะนำโดยบริษัท ดังนั้น
              การเข้าถึงเว็บไซต์อื่นที่เชื่อมกับเว็บไซต์นี้จึงถือเป็นความเสี่ยงของตัวท่านเอง
              ซึ่งทางบริษัทขอปฏิเสธความรับผิดชอบทั้งหมดที่เกี่ยวข้องกับการเข้าถึงลิงค์เว็บไซต์ดังกล่าวของท่าน
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              6.3 บริษัทจะไม่ติดตามและตรวจสอบเนื้อหาของหน้าเว็บไซต์ภายนอก
              หรือเว็บไซต์อื่นที่เชื่อมโยงกับเว็บไซต์ของบริษัท และจะไม่รับผิดชอบ
              หรือรับผิดใด ๆ ที่เกิดจากเนื้อหาของหน้าเว็บไซต์ภายนอก
              หรือเว็บไซต์ดังกล่าวนั้น หรือสำหรับความผิดพลาด การหมิ่นประมาท
              การกล่าวโจมตี การใส่ร้าย การละเว้น การกล่าวเท็จ
              ข้อความหรือพฤติกรรมอันเป็นเท็จหรือทำให้เข้าใจผิด ข้อความหยาบคาย
              ลามก อนาจาร การดูหมิ่น สิ่งอันตราย หรือไม่ถูกต้อง การฝ่าฝืน
              หรือสิ่งผิดกฎหมาย ที่มีอยู่ในข้อมูลใด ๆ บนเว็บไซต์ภายนอก
              หรือเว็บไซต์ดังกล่าวนั้น
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              6.4 บริษัทสงวนสิทธิ์ไม่ดำเนินการใด ๆ
              และไม่ต้องรับผิดชอบในบรรดาความเสียหายอย่างใด ๆ
              ที่เกิดขึ้นต่อท่านและ/หรือบุคคลภายนอก
              หากท่านไม่ได้สมัครสมาชิกผ่านเว็บไซต์นี้
              หรือไม่ได้ใช้งานเว็บไซต์นี้ ในการรับมอบหมายงาน หรือท่านนำส่งเอกสาร
              ข้อมูล และ/หรือรายละเอียดขึ้นเว็บไซต์ไม่ถูกต้องครบถ้วน เช่น
              ข้อมูลพนักงานขับรถ, ข้อมูลรถขนส่ง, กรมธรรม์ประกันภัย, คำรับรอง,
              หน้าบัญชีธนาคาร เป็นต้น โดยท่านตกลงไม่โต้แย้งถึงความเป็นเจ้าของ,
              การควบคุมหรือกำกับดูแล หรือการมีอยู่ของพนักงานขับรถหรือรถขนส่ง
              ซึ่งได้กระทำในนามของท่าน
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              6.5
              ท่านตกลงว่าบริษัทไม่ต้องรับผิดจากการที่บริษัทไม่สามารถปฏิบัติตามข้อตกลงได้อันเนื่องมาจากเหตุสุดวิสัย
              เช่น ในกรณีที่มีความชำรุดบกพร่อง เสียหาย ขัดข้อง
              หรือล่าช้าของระบบคอมพิวเตอร์ และ/หรือระบบไฟฟ้า
              ระบบเครือข่ายอินเทอร์เน็ต (Internet) ระบบการติดต่อสื่อสาร
              ปัญหาทางด้านพลังงาน ภัยพิบัติธรรมชาติ การกระทำของบุคคลภายนอก
              การกระทำของหน่วยงานรัฐบาล ไฟไหม้ การประท้วง การขนส่งติดขัด
              การจลาจล สงคราม ไวรัสคอมพิวเตอร์ ข้อมูลที่เป็นอันตรายต่าง ๆ
              (Harmful Data) หรือเหตุต่าง ๆ อันอยู่นอกเหนือจากการควบคุม
              ซึ่งเป็นอุปสรรคต่อการที่ท่านจะเข้าใช้งานเว็บไซต์
            </TextRegular>
          </MessageDisplay>
          <MessageDisplay title="7.	ความรับผิดของบริษัท">
            <TextRegular color={theme.palettes.black85}>
              ไม่ว่ากรณีใด ๆ บริษัทไม่มีความผิดสำหรับการสูญเสียกำไร รายได้
              ทางธุรกิจ ความนิยมและชื่อเสียง ความคาดหวัง ไม่ว่าโดยตรงหรือโดยอ้อม
              หรือผลสืบเนื่องซึ่งเกิดจาก
              หรือเกี่ยวข้องกับการที่ท่านใช้งานหรือไม่สามารถใช้งานเว็บไซต์นี้
              เว็บไซต์ที่เชื่อมโยง หรือเนื้อหาใด ๆ ที่มีอยู่ในนั้น
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85}>
              ในกรณีที่บริษัทถูกฟ้องร้องไม่ว่าด้วยเหตุใดเกี่ยวกับการใช้งานเว็บไซต์นี้
              ท่านตกลงที่จะให้ความช่วยเหลือเท่าที่จำเป็นทั้งหมด
              ในการให้การต่อสู้คดี หรือทำข้อตกลงระงับคดีใด ๆ นั้น
              รวมถึงการเข้าเป็นจำเลยร่วมในการต่อสู้คดีจนถึงที่สุด
            </TextRegular>
          </MessageDisplay>
          <MessageDisplay title="8.	ค่าสินไหมทดแทน">
            <TextRegular color={theme.palettes.black85}>
              ท่านตกลงที่จะชดใช้ค่าเสียหายเต็มจำนวนให้แก่บริษัท ต่อการกระทำ
              การดำเนินการ ความสูญเสีย หนี้สิน ความเสียหาย การเรียกร้อง
              ความต้องการ ต้นทุนและค่าใช้จ่าย (ซึ่งรวมถึงค่าใช้จ่ายทางกฎหมาย
              ค่าทนายความ) ทั้งหมดที่ทางบริษัทประสบ หรือรับผิดชอบ
              ซึ่งเป็นผลมาจากหรือเกี่ยวข้องกับการกระทำ
              หรือการละเว้นการกระทำของท่าน หรือเป็นการฝ่าฝืนใด ๆ ต่อข้อตกลงนี้
              หรือเกี่ยวข้องกับการเรียกร้องใด ๆ จากบุคคลภายนอก สำหรับการละเมิด
              หรือการฝ่าฝืนใด ๆ
            </TextRegular>
          </MessageDisplay>
          <MessageDisplay title="9.	ข้อมูลส่วนบุคคล">
            <TextRegular color={theme.palettes.black85} margin="15px">
              9.1
              ท่านรับรองและรับประกันว่าได้ตรวจสอบความถูกต้องและความสมบูรณ์ของข้อมูลส่วนบุคคลที่ท่านให้แก่บริษัท
              และจะแจ้งแก่บริษัท หากมีการเปลี่ยนแปลงใด ๆ
              ในข้อมูลส่วนบุคคลที่ได้ให้ไว้
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              9.2
              ท่านรับรองและรับประกันว่าข้อมูลส่วนบุคคลที่ท่านให้แก่บริษัทได้รับความยินยอมหรือสามารถอาศัยฐานทางกฎหมายอื่นสำหรับการเก็บรวบรวม
              ใช้ เปิดเผย
              และ/หรือโอนข้อมูลส่วนบุคคลตามที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลกำหนด
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              9.3
              ท่านรับรองและรับประกันว่าท่านได้ศึกษาประกาศเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคล
              (Privacy Notice)
              สำหรับกระบวนการที่เกี่ยวข้องกับคู่ค้าของบริษัทแล้ว และ
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              9.4 ท่านรับรองและรับประกันว่าบริษัทสามารถเก็บรวบรวม ใช้ เปิดเผย
              และ/หรือโอนข้อมูลส่วนบุคคลตามวัตถุประสงค์ทั้งหมดที่กำหนดในข้อตกลงนี้
              โดยบริษัทมีการคุ้มครองข้อมูลส่วนบุคคลตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลของบริษัท
              ซึ่งมีมาตรการด้านความมั่นคงปลอดภัยที่เหมาะสมตามที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลกำหนด
            </TextRegular>
          </MessageDisplay>
          <MessageDisplay title="10. การรักษาความลับ">
            <TextRegular color={theme.palettes.black85}>
              ท่านตกลงว่าจะไม่เปิดเผย หรืออนุญาตให้ตัวแทน
              หรือผู้แทนเปิดเผยข้อมูลใด ๆ
              ซึ่งโดยสภาพหรือบริษัทกำหนดว่าเป็นความลับซึ่งรวมถึงแต่ไม่จำกัดเฉพาะข้อมูลที่เกี่ยวข้องกับข้อความในข้อตกลงนี้แก่บุคคลใด
              ๆ โดยปราศจากความยินยอมเป็นลายลักษณ์อักษรของบริษัทไม่ว่าเวลาใด
              เว้นแต่การเปิดเผยข้อมูลตามที่กฎหมายกำหนด
              หรือหน่วยงานราชการที่มีอำนาจตามกฎหมาย หรือศาล
              ซึ่งท่านจะต้องแจ้งให้บริษัททราบล่วงหน้าตามสมควรก่อนการเปิดเผยข้อมูล
              ทั้งนี้ หากเกิดความเสียหายใด ๆ
              เนื่องจากการที่ท่านเปิดเผยข้อมูลอันเป็นความลับแก่บุคคลภายนอก
              โดยมิได้รับความยินยอมเป็นลายลักษณ์อักษรจากบริษัท
              ท่านจะต้องรับผิดชอบในความเสียหายที่เกิดขึ้นแต่เพียงผู้เดียว
            </TextRegular>
          </MessageDisplay>
          <MessageDisplay title="11. อื่น ๆ">
            <TextRegular color={theme.palettes.black85} margin="15px">
              11.1 หัวข้อที่ใช้ในข้อตกลงนี้มีไว้ใช้เพื่อความสะดวกเท่านั้น
              และไม่ให้ใช้หัวข้อดังกล่าวในการกำหนดความหมายหรือตีความข้อตกลงเหล่านี้
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              11.2
              ให้ถือว่าข้อตกลงอื่นที่กำหนดไว้แล้วในขณะนี้และ/หรือที่จะมีขึ้นต่อไปในภายหน้า
              เป็นส่วนหนึ่งของข้อตกลงนี้
              ในกรณีที่ข้อความใดในข้อตกลงและข้อตกลงอื่นที่กำหนดไว้จะมีขึ้นต่อไปในอนาคต
              หรือเนื้อหาในข้อตกลงนี้ ขัดหรือแย้งกัน
              ให้ยึดถือคำวินิจฉัยของบริษัทเป็นที่สุด โดยท่านไม่มีสิทธิโต้แย้ง
              และ/หรือเรียกร้องค่าเสียหายหรือค่าใช้จ่ายใด ๆ ทั้งสิ้นจากบริษัท
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              11.3
              ไม่มีข้อกำหนดใดในข้อตกลงนี้ถูกตีความได้ว่าท่านมีความสัมพันธ์เป็นตัวแทน
              พนักงาน ลูกจ้าง หรือหุ้นส่วนของบริษัท
              เพียงแต่เป็นผู้รับจ้างหรือผู้รับเหมาอิสระเพื่อเข้าปฏิบัติงานภายใต้เงื่อนไขและข้อตกลงของบริษัทเป็นการชั่วคราว
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              11.4 หากเงื่อนไขของข้อตกลงใด ๆ
              ถือเป็นโมฆะหรือไม่สามารถบังคับใช้ได้ ความชอบด้วยกฎหมาย ความสมบูรณ์
              และการบังคับใช้ของข้อตกลงที่เหลือจะไม่ได้รับผลกระทบหรือทำให้บกพร่อง
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              11.5
              การที่บริษัทยินยอมยกเว้นหรือไม่ได้ใช้สิทธิข้อใดข้อหนึ่งตามข้อตกลงนี้ไม่ว่าครั้งเดียวหรือหลายครั้งก็ตาม
              มิให้ถือว่าบริษัทยินยอมหรือสละสิทธิตามข้อตกลงนี้บางส่วนหรือทั้งหมดในครั้งต่อไปด้วย
              โดยท่านยังคงมีหน้าที่ปฏิบัติตามข้อตกลงนี้โดยเคร่งครัดทุกประการ
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              11.6
              ท่านรับทราบและยินยอมให้บริษัทโอนสิทธิตามข้อตกลงนี้โดยไม่ต้องได้รับความยินยอมจากท่าน
              โดยจะแจ้งให้ท่านทราบเกี่ยวกับการโอนสิทธิและหน้าที่
              หรือการควบรวมกิจการดังกล่าว
              ข้อตกลงนี้จะมีผลผูกพันกับผู้รับโอนสิทธิทั้งหมด
              เว้นแต่จะระบุไว้เป็นอย่างอื่น
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              11.7 เอกสาร หรือหนังสือใด ๆ ที่บริษัทส่งไปยังท่านตามที่อยู่
              และ/หรือสำนักงานตามที่ท่านได้แจ้งไว้กับบริษัท
              ถือว่าท่านได้ทราบข้อความในเอกสารหรือหนังสือนั้น ๆ แล้ว
              หากมีการเปลี่ยนแปลงที่อยู่
              เป็นหน้าที่ของท่านที่จะต้องแจ้งให้บริษัททราบเป็นลายลักษณ์อักษรทันที
              มิฉะนั้น
              ท่านยินยอมให้ถือว่าที่อยู่เดิมเป็นที่อยู่ที่ถูกต้องและหากบริษัทได้ส่งไปยังที่อยู่นั้น
              ให้ถือว่าเป็นการบอกกล่าวที่ถูกต้องโดยชอบด้วยกฎหมาย
            </TextRegular>
          </MessageDisplay>
          <MessageDisplay title="12. กฎหมายที่ใช้บังคับ">
            <TextRegular color={theme.palettes.black85} margin="15px">
              12.1 เว็บไซต์
              และเนื้อหาที่อธิบายบนเว็บไซต์นี้มีวัตถุประสงค์เพื่อให้ใช้งานโดยผู้ที่มีถิ่นพำนักอยู่ในประเทศไทยเท่านั้น
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              12.2
              ข้อตกลงนี้ให้ใช้บังคับและตีความตามกฎหมายไทยและให้ศาลไทยเป็นศาลที่มีเขตอำนาจในการพิจารณาข้อพิพาทที่เกิดขึ้นตามข้อตกลงนี้
            </TextRegular>
            <br />
            <TextRegular color={theme.palettes.black85} margin="15px">
              12.3 หากท่านใช้เว็บไซต์นี้จากภายนอกประเทศไทย
              ท่านมีหน้าที่ต้องปฏิบัติตามกฎหมายไทย
            </TextRegular>
          </MessageDisplay>
        </div>
      </DriverPortalLayout>
    </>
  );
};

const TermsAndCondition: React.FC<ITermsAndConditionProps> = () => {
  return (
    <>
      <HeaderPortal />
      <DriverPortalLayout>
        <Title>ข้อตกลงเงื่อนไขการเป็นผู้ให้บริการขนส่ง (Rider)</Title>
        <Divider />
        <div>
          <TextRegular color={theme.palettes.black85}>
            ผู้ให้บริการขนส่ง
            (ซึ่งต่อไปในข้อตกลงเงื่อนไขการเป็นผู้ให้บริการฉบับนี้ จะเรียกว่า
            “Rider”) รับทราบและตกลงว่า บริษัท ออลล์ นาว แมนเนจเม้นท์ จำกัด
            สำนักงานแห่งใหญ่ตั้งอยู่เลขที่ 119 ชั้น 8 อาคารธาราสาทร ถนนสาทรใต้
            แขวงทุ่งมหาเมฆ เขตสาทร กรุงเทพมหานคร
            (ซึ่งต่อไปในเอกสารฉบับนี้จะเรียกว่า “AM” อีก ฝ่ายหนึ่ง)
            เป็นผู้ว่าจ้างให้ Rider ทำการให้บริการขนส่งสินค้าให้แก่ AM
            ตามมาตรฐานการขนส่งสินค้าของ AM และตามต้นทาง - ปลายทางที่ AM แจ้งให้
            Rider ทราบ (ซึ่งต่อไปในข้อตกลงเงื่อนไขการเป็นผู้ให้บริการ ขนส่ง
            (Rider) นี้ จะเรียกว่า “การให้บริการ”) ทั้งนี้ Rider
            ตกลงรับทราบและตกลงปฏิบัติตามข้อตกลงเงื่อนไข การเป็นผู้ให้บริการขนส่ง
            (Rider)(ซึ่งต่อไปในข้อตกลงเงื่อนไข การเป็นผู้ให้บริการขนส่ง (Rider)
            นี้ จะเรียกว่า “เงื่อนไขการให้บริการ”)
            และตกลงยอมรับถึงเงื่อนไขการให้บริการที่ AM อาจประกาศผ่านทาง เว็บไซต์
            หรือช่องทางการสื่อสารอื่นใด (หากมี) โดยมีรายละเอียดดังนี้
          </TextRegular>
          <Divider />
          <MessageDisplay
            title="1. Rider ได้รับรองและแสดงเจตนาอย่างชัดแจ้งว่าตนเป็น ผู้มีสิทธิ์
        ตามกฎหมาย"
          >
            Rider ได้รับรองและแสดงเจตนาอย่างชัดแจ้งว่า ตนเป็นผู้มีสิทธิ์
            ตามกฎหมาย สามารถให้ความยินยอมแก่เงื่อนไขการเป็นผู้ให้บริการ ขนส่ง
            (Rider) ฉบับนี้ สามารถแสดงเจตนาทำ นิติกรรมสัญญาโดยอิสระ
            และไม่เป็นบุคคลต้องห้ามมิให้ทำนิติกรรมสัญญาตามที่กฎหมายกำหนด ทั้งนี้
            Rider ขอให้คำรับรองว่าบรรดาเอกสาร และ/หรือ ข้อมูลอื่นใด
            ที่นำส่งให้กับ AM เป็นข้อมูลที่ถูกต้อง และชอบด้วยกฎหมาย
          </MessageDisplay>
          <MessageDisplay
            title="2. Rider ตกลงเป็นผู้ให้บริการขนส่งสินค้าแก่ AM และ ตกลงให้บริการ
        ตามมาตรฐานการขนส่งสินค้าที่ AM กำหนด"
          >
            Rider ตกลงเป็นผู้ให้บริการขนส่งสินค้าแก่ AM และตกลงให้บริการ
            ตามมาตรฐานการขนส่งสินค้าที่ AM กำหนด ตกลงให้บริการ ตามต้นทาง -
            ปลายทางที่ AM แจ้งให้ Rider ทราบเป็นคราวๆ ผ่านทางช่องทางการ
            ติดต่อสื่อสารใดๆ ที่ AM กำหนด (หากมี) และตกลงให้บริการตามกำหนด
            เวลาการให้บริการตามที่ AM แจ้งให้ทราบ โดย Rider สามารถอ่าน
            รายละเอียดได้จาก&nbsp;
            <a
              href="https://bit.ly/ANLQC"
              target="_blank"
              rel="noopener noreferrer"
            >
              bit.ly/ANLQC
            </a>
            &nbsp;หรือ&nbsp;
            <a
              href="https://docs.google.com/document/d/1XQHQ86WN4XVJnQcpzKN48zS7qksmQkqbaVRdTfB0mzE"
              target="_blank"
              rel="noopener noreferrer"
            >
              ข้อตกลงและมาตรฐานในการให้บริการของ Rider
            </a>
          </MessageDisplay>
          <MessageDisplay
            title="3. Rider จะได้รับค่าขนส่งเมื่อได้ให้บริการขนส่งอย่างถูกต้อง ครบถ้วน
        ตามที่ AM กำหนดตามรอบการขนส่ง"
          >
            Rider จะได้รับค่าขนส่งเมื่อได้ให้บริการขนส่งอย่างถูกต้องครบถ้วน
            ตามที่ AM กำหนดตามรอบการขนส่ง โดยที่ AM จะรวบรวมค่าขนส่ง
            ของรอบการขนส่งตั้งแต่วันจันทร์ถึง วันอาทิตย์ ในแต่ละสัปดาห์
            และจะชำระค่าขนส่งให้กับ Rider ภายใน รอบการจ่ายเงิน ที่ AM กำหนด
            Rider ตกลงยอมรับและเข้าใจว่า เงินค่าขนส่ง หมายถึงค่าตอบแทน
            การให้บริการขนส่งที่ AM จ่ายให้ ทั้งนี้ บรรดาค่าเชื้อเพลิง,
            ค่าสัมภาระ, ค่าวัสดุอุปกรณ์, ค่าภาษีรถจักรยายนต์, ค่าโทรศัพท์
            และค่าใช้จ่ายต่างๆ ที่เกี่ยวข้องกับการให้บริการขนส่งสินค้า Rider
            เป็นผู้รับผิดชอบค่าใช้จ่าย ดังกล่าวเองทั้งสิ้น Rider
            ตกลงและรับทราบว่าอัตราค่าขนส่งที่ AM กำหนด จะสะท้อนถึง
            ต้นทุนของการดำเนินการขนส่งต่างๆ รวมถึงราคาแก๊สโซฮอล์ 91 ในช่วงนั้นๆ
            โดยรายละเอียดอัตราค่าขนส่ง ทั้งนี้ สามารถอ้างอิงได้จาก ประกาศจากทาง
            AM ตามที่ AM กำหนด
          </MessageDisplay>
          <MessageDisplay
            title="4. เงื่อนไขการให้บริการฉบับนี้ มีกำหนดเวลาว่าจ้าง 1 ปี นับแต่วันที่
        Rider ตกลงรับทราบเงื่อนไขการเป็นผู้ให้ บริการขนส่ง"
          >
            Rider ตกลงยอมรับและเข้าใจว่าการว่าจ้างให้ Rider เป็นผู้ให้บริการ
            ตามเงื่อนไขการให้บริการฉบับนี้ มีกำหนดเวลาว่าจ้าง 1 ปี นับแต่วันที่
            Rider ตกลงรับทราบเงื่อนไขการเป็นผู้ให้บริการขนส่ง อย่างไรก็ดี AM
            ขอสงวนสิทธิในการบอกเลิกการว่าจ้างการให้บริการ ตามที่ AM เห็นสมควร
            หาก Rider ไม่สามารถให้บริการขนส่งตาม มาตรฐาน การให้บริการที่ AM
            กำหนด และ/หรือกระทำการใดๆ อันเป็นการทุจริต กระทำผิดกฎหมาย
            และกระทำผิดเงื่อนไขการให้บริการ ขนส่ง ทั้งนี้ Rider
            ตกลงจะไม่เรียกร้องค่าเสียหายใดๆ จากการบอกเลิก การว่าจ้าง ให้บริการ
            ก่อนครบกำหนด อนี่ง ถึงวันครบกำหนดเวลา ว่าจ้างแล้ว หาก AM
            มิได้แสดงเจตนา บอกเลิกการว่าจ้างให้บริการ กรณีนี้ Rider และ AM
            ตกลงให้ข้อตกลง เงื่อนไขการเป็นผู้ให้ บริการขนส่ง (Rider)
            ฉบับนี้ต่ออายุโดยอัตโนมัติไป คราวละ 1 ปี และให้ถือว่าการว่าจ้างให้
            Rider เป็นผู้ให้บริการขนส่ง ยังคงมีผลบังคับ
            ใช้ตามเงื่อนไขเดิมต่อไปทุกประการ
          </MessageDisplay>
          <MessageDisplay
            title="5. Rider ตกลงและเป็นผู้รับผิดชอบค่าภาษีเงินได้หัก ณ ที่จ่าย
        และอากรแสตมป์ (ถ้ามี) ที่เกิดขึ้นตามการ ว่าจ้างให้บริการนี้"
          ></MessageDisplay>
          <MessageDisplay title="6. Rider เข้าใจและตกลงปฏิบัติหน้าที่ตามเงื่อนไขดังต่อไปนี้">
            <MessageDisplay
              title="6.1. Rider ตกลงจัดหารถจักรยายนต์มาใช้ในการขนส่งให้แก่ AM"
              fontSize={theme.fontSize.xs}
            >
              Rider ตกลงจัดหารถจักรยายนต์มาใช้ในการขนส่งให้แก่ AM
              ตามข้อตกลงเงื่อนไขการให้บริการโดยต้องเป็นรถจักรยานยนต์
              ที่มีสภาพดังต่อไปนี้
              <BulletList
                items={[
                  'Rider ต้องจัดหารถจักรยายนต์ที่มีสภาพตัวรถ เครื่องยนต์ โครงสร้าง อยู่ในสภาพสมบูรณ์ แข็งแรง สะอาด มีความปลอดภัย และเหมาะสมกับการให้บริการ',
                  'Rider ต้องจัดให้มีการตรวจสภาพรถจักรยายนต์ตามที่กฎหมาย กำหนด และปฏิบัติให้ถูกต้องตามกฎหมายทุกประการ',
                  'Rider ต้องใช้รถจักรยายนต์ที่จดทะเบียนถูกต้องตามกฎหมาย และจัดทำประกันภัยคุ้มครองผู้ประสบภัยจากรถ ทั้งนี้ Rider ตกลงเป็นผู้รับภาระค่าเบี้ยประกันภัยและค่าใช้จ่ายในการดังกล่าว ข้างต้นทั้งหมด พร้อมทั้งส่งมอบสำเนากรมธรรม์ประกันภัย คุ้มครองผู้ประสบภัยจากรถ, สำเนาคู่มือการจดทะเบียน รถจักรยายนต์, สำเนาบัตรประชาชน ของคนขับรถจักรยายนต์ และสำเนาใบขับขี่รถจักรยายนต์ของ Rider ที่ถูกต้องตามกฎหมาย ให้แก่ AM ภายใน 7 (เจ็ด) วัน นับแต่วันที่ตกลงรับทราบ เงื่อนไขการให้บริการ หาก Rider มีการเปลี่ยนแปลงข้อมูลเกี่ยวกับ รถจักรยายนต์ หรือต้องการเปลี่ยนรถจักรยายนต์ที่จะนำมา ขนส่งสินค้าตามสัญญานี้ Rider ต้องส่งมอบสำเนาเอกสารดังกล่าว พร้อมทั้งแจ้งให้ AM ทราบภายใน 3 (สาม) วัน นับตั้งแต่วันที่มีการ เปลี่ยนแปลงข้อมูล',
                ]}
              />
              ทั้งนี้ AM ขอสงวนสิทธิสำหรับการอนุญาตหรือไม่อนุญาตให้ Rider
              ใช้รถจักรยายนต์คันหนึ่งคันใดให้บริการขนส่งสินค้าให้กับ AM
            </MessageDisplay>
            <MessageDisplay
              title="6.2. Rider ต้องจัดหาโทรศัพท์ SMART PHONE ระบบ Android เพื่อรองรับ
          กระบวนการทำงาน"
              fontSize={theme.fontSize.xs}
            >
              Rider ต้องจัดหาโทรศัพท์ SMART PHONE ระบบ Android เพื่อรองรับ
              กระบวนการทำงานตั้งแต่การรับ-ส่งสินค้า และการให้บริการ โดย Rider
              ตกลงรับผิดชอบค่าใช้จ่ายทั้งหมด
            </MessageDisplay>
            <MessageDisplay
              title="6.3. หาก Rider พบเห็นเสียหายเกิดขึ้นแก่สินค้าและหรือพัสดุภัณฑ์ Rider
          ต้องแจ้งให้ AM ทราบทันที"
              fontSize={theme.fontSize.xs}
            >
              ก่อนเข้าขนส่งสินค้าทุกครั้ง หาก Rider พบเห็นความชำรุด บกพร่อง
              และหรือเสียหายเกิดขึ้นแก่สินค้าและหรือพัสดุภัณฑ์ Rider ต้องแจ้งให้
              AM ทราบทันที ทั้งนี้ หาก Rider ละเลยไม่แจ้งให้ AM ทราบ Rider
              ตกลงเป็นผู้รับผิดในความเสียหายที่เกิดขึ้นทั้งสิ้น
            </MessageDisplay>
            <MessageDisplay
              title="6.4. หาก Rider ทำการขนส่งสินค้าล่าช้ากว่ากำหนด หรือมี อุบัติเหตุใดๆ
          เกิดขึ้นจากสภาพรถจักรยายนต์ หรือจากการละเมิด
          การฝ่าฝืนพระราชบัญญัติจราจร Rider จะต้องแจ้งเหตุให้ AM ทราบ ทันที
          รวมทั้งเป็นผู้รับผิดชอบค่าเสียหายตามจำนวนที่เกิดขึ้นจริง ทั้งหมด"
              fontSize={theme.fontSize.xs}
            >
              ในระหว่างการให้บริการ หาก Rider ทำการขนส่งสินค้าล่าช้า กว่ากำหนด
              สินค้าสูญหายหรือเสียหาย หรือมีอุบัติเหตุใดๆ เกิดขึ้น
              ไม่ว่าจะเนื่องมาจากสภาพรถจักรยายนต์ การขับขี่รถจักรยายนต์
              เกิดการละเมิดการฝ่าฝืนพระราชบัญญัติจราจร หรือพระราชบัญญัติ
              ขนส่งทางบก หรือกฎหมายอื่นใดที่เกี่ยวข้องกับการขนส่งสินค้า
              ตามสัญญานี้ หรือเหตุอื่นใด Rider จะต้องแจ้งเหตุให้ AM ทราบทันที
              รวมทั้ง Rider
              ต้องเป็นผู้รับผิดชอบค่าเสียหายตามจำนวนที่เกิดขึ้นจริง ทั้งหมด
              และค่าใช้จ่ายที่ต้องจัดหารถมาเปลี่ยนถ่ายสินค้าเพื่อส่งสินค้า
              แก่ผู้รับสินค้า ณ ปลายทาง ให้เป็นไปตามรอบการส่งสินค้าที่กำหนดไว้ใน
              ใบส่งสินค้า ทั้งนี้ Rider ส่งต้องนำสินค้าที่ได้รับความเสียหาย
              และหรือซากทรัพย์สินค้าทั้งหมดส่งคืนให้แก่ AM จนครบถ้วน
              ด้วยค่าใช้จ่ายของ Rider เองทั้งหมด
            </MessageDisplay>
            <MessageDisplay
              title="6.5. Rider ตกลงส่งมอบสินค้าให้แก่ผู้รับสินค้า ณ ปลายทาง
          ตามสถานที่และเวลาที่ AM กำหนดในใบส่งสินค้า"
              fontSize={theme.fontSize.xs}
            >
              Rider ตกลงส่งมอบสินค้าให้แก่ผู้รับสินค้า ณ ปลายทาง ตามสถานที่และ
              เวลาที่ AM กำหนดในใบส่งสินค้าและในกรณีที่ Rider ทำการขนส่งสินค้า
              ล่าช้ากว่ากำหนด / สินค้าสูญหายหรือเสียหาย ไม่ว่าด้วยสาเหตุใดๆ
              จนเป็นเหตุให้ AM ต้องรับผิดชอบชดใช้ค่าปรับ หรือค่าเสียหายแก่ลูกค้า
              ของ AM หรือบุคคลภายนอก Rider ตกลงชำระค่าปรับเป็นเงินจำนวน 500. -
              บาท (ห้าร้อยบาทถ้วน) ต่อเที่ยวและตกลงชดใช้ค่าเสียหาย
              ทั้งหมดตามจำนวนที่เกิดขึ้นจริงทั้งหมด ให้แก่ AM โดย Rider ตกลง
              ชดใช้ค่าปรับหรือค่าเสียหายแทน ให้แก่ AM ทั้งสิ้น
              ทั้งนี้หากความเสียหาย ดังกล่าวเกิดจากการจงใจของ Rider Rider
              ตกลงยินยอมชำระค่าปรับ ให้แก่ AM เป็นจำนวน 2 (สอง)
              เท่าของค่าเสียหายที่เกิดขึ้น
            </MessageDisplay>
            <MessageDisplay
              title="6.6. Rider ยินดีปฏิบัติตามข้อกำหนด ที่เกี่ยวกับข้องกับอุปกรณ์
          เพื่อการให้บริการขนส่ง"
              fontSize={theme.fontSize.xs}
            >
              Rider ตกลงรับทราบ และยินดีปฏิบัติตามข้อกำหนด ที่เกี่ยวกับข้องกับ
              อุปกรณ์เพื่อการให้บริการขนส่ง เช่น กระเป๋า เสื้อแจ๊กเก็ต
              หรืออุปกรณ์ อื่นใดที่เกี่ยวข้องกับการให้บริการของ Rider ตามที่ AM
              กำหนด
            </MessageDisplay>
            <MessageDisplay
              title="6.7. ในระหว่างการขนส่งสินค้าให้แก่ AM ตามสัญญานี้ Rider
          ต้องแต่งกายด้วยชุดสุภาพเรียบร้อย"
              fontSize={theme.fontSize.xs}
            >
              ในระหว่างการขนส่งสินค้าให้แก่ AM ตามสัญญานี้ Rider
              ต้องแต่งกายด้วยชุดสุภาพเรียบร้อย, สะอาด, ไม่ฉีกขาด,
              สวมใส่รองเท้าหุ้มส้น, เล็บมือต้องสะอาด ไม่ยาว ไม่ดำ และ Rider
              ต้องมีสภาพร่างกายที่สมบูรณ์ แข็งแรง, มีความพร้อมในการทำงาน,
              มีความประพฤติสุภาพเรียบร้อย กิริยามารยาทดี รวมทั้งห้าม
              ดื่มสิ่งของมึนเมา หรือสารเสพติด ตลอดจนกระทำทุจริต หรือกระทำ
              ผิดกฎหมายใดๆ ทั้งสิ้น ทั้งนี้ หาก Rider
              ปฏิบัติผิดเงื่อนไขดังกล่าวข้างต้น AM มีสิทธิบอกเลิก
              การว่าจ้างให้บริการเป็นผู้ขนส่งได้ทันที
              และขอสงวนสิทธิเรียกค่าเสียหาย ที่เกิดขึ้น ได้เต็มตามจำนวนที่ Rider
              ได้ก่อให้เกิดขึ้นทั้งหมด
            </MessageDisplay>
            <MessageDisplay
              title="6.8. Rider ตกลงปฏิบัติตามขั้นตอน วิธีการทำงานตามที่ AM กำหนด
          และตามที่ Rider ได้รับการอบรมก่อนเริ่มการให้บริการ"
              fontSize={theme.fontSize.xs}
            />
            <MessageDisplay
              title="6.9. Rider ตกลง และยินยอมให้หักเงินค่าปรับและ หรือค่าเสียหาย และหรือ
          ค่าใช้จ่ายดังกล่าวออกจากเงินค่าขนส่งได้ในขั้นแรก"
              fontSize={theme.fontSize.xs}
            >
              บรรดาเงินค่าปรับและหรือค่าเสียหายและหรือค่าใช้จ่ายใดๆ ที่ Rider
              มีหน้าที่ต้องรับผิดชอบตามสัญญานี้ Rider ตกลง และยินยอมให้ AM
              หักเงินค่าปรับและหรือค่าเสียหายและหรือค่าใช้จ่ายดังกล่าว ออกจาก
              เงินค่าขนส่งได้ในขั้นแรก และหากจำนวนเงินค่าปรับ และหรือค่าเสียหาย
              และหรือค่าใช้จ่ายยังขาดอยู่ Rider ยินยอมให้ AM
              เรียกเก็บเงินค่าปรับ เพิ่มเติมได้ตามจริง กรณีนี้ Rider
              ตกลงต้องชำระค่าปรับและหรือค่า
              เสียหายและหรือค่าใช้จ่ายที่ยังขาดอยู่นั้นให้แก่ AM ภายใน 30 วัน
              นับแต่วันที่บริษัทได้แจ้งให้ทราบ
            </MessageDisplay>
          </MessageDisplay>
          <MessageDisplay title="7. AM ไม่มีความสัมพันธ์ในฐานะนายจ้างและลูกจ้างกับ Rider">
            Rider ตกลงและรับทราบดีว่า AM ไม่มีความสัมพันธ์ในฐานะนายจ้าง
            และลูกจ้างกับ Rider และไม่มีหน้าที่และความรับผิดชอบใดๆ ต่อ Rider
            ตามกฎหมายคุ้มครองแรงงาน และกฎหมายแรงงาน อีกทั้ง AM
            ไม่มีหน้าที่ต้องจัดวันหยุดประจำสัปดาห์, วันหยุดตามประเพณี,
            วันหยุดพักผ่อนประจำปี รวมทั้งไม่ต้องจ่ายค่าสวัสดิการ ค่าล่วงเวลา
            หรือสิทธิประโยชน์อื่นใดนอกเหนือไปจากค่าขนส่งที่กำหนดไว้
          </MessageDisplay>
          <MessageDisplay title="8. Rider จะไม่เอาการขนส่งทั้งหมด หรือส่วนหนึ่งส่วนใด ตามสัญญานี้ ไปให้บุคคลอื่นทำแทน">
            Rider ตกลงและรับทราบว่าตนจะไม่เอาการขนส่งทั้งหมด หรือส่วนหนึ่ง
            ส่วนใด ตามสัญญานี้ ไปให้บุคคลอื่นทำแทนเว้นแต่ จะได้รับความยินยอม
            เป็นลายลักษณ์อักษรจาก AM และถึงแม้ AM จะอนุญาตไว้ก็ตาม Rider
            ยังคงต้องเป็นผู้รับผิดชอบอยู่ทุกประการ และตกลงจะไม่โอนสิทธิ
            ทั้งหมดหรือแต่บางส่วน ตามสัญญานี้ ให้แก่บุคคลอื่นหรือนิติบุคคลใดๆ
          </MessageDisplay>
          <MessageDisplay title="9. ข้อมูลหรือเอกสารอื่นใดที่ AM ให้แก่ Rider ถือเป็นข้อมูล ที่เป็น ความลับของ AM โดย Rider ไม่มีสิทธินำไปใช้ไม่ว่า กรณีใดๆ ทั้งสิ้น">
            Rider ตกลงและรับทราบว่าบรรดาข้อมูล หรือเอกสารอื่นใดที่ AM ให้แก่
            Rider เพื่อการปฏิบัติงานถือเป็นข้อมูล หรือเอกสารที่เป็นความลับ ของ
            AM โดย Rider ไม่มีสิทธินำไปใช้ไม่ว่ากรณีใดๆ ทั้งสิ้น และไม่ว่าจะ
            มีค่าตอบแทนหรือไม่ก็ตาม เว้นแต่ Rider จะได้รับความยินยอมเป็น
            ลายลักษณ์อักษรจาก AM หรือกรณีที่ Rider จะต้องเปิดเผยตาม คำสั่งศาล
            Riderจะต้องแจ้งเป็นลายลักษณ์อักษรให้ AM ทราบโดยเร็ว
          </MessageDisplay>
          <MessageDisplay title="10.  กรณีที่ Rider หรือ AM ปฏิบัติผิดสัญญา ฝ่ายที่ มิได้ปฏิบัติผิด สัญญามีสิทธิบอกเลิกสัญญา ได้ทันที">
            และเรียกค่าเสียหายที่เกิดขึ้นได้เต็มตามจำนวนที่เกิดขึ้นทั้งหมดกรณีที่
            Rider หรือ AM ฝ่ายหนึ่งฝ่ายใดปฏิบัติผิดสัญญา
            ข้อใดข้อหนึ่งที่มิใช่สาระสำคัญ และเพิกเฉย หรือมิได้แก้ไขให้ถูกต้อง
            ภายใน 30 (สามสิบ) วัน
            นับแต่วันที่ได้รับหนังสือบอกกล่าวจากฝ่ายที่มิได้ ปฏิบัติผิดสัญญา
            ฝ่ายที่มิได้ปฏิบัติผิดสัญญามีสิทธิบอกเลิกสัญญา ได้ทันที
            และเรียกค่าเสียหายที่เกิดขึ้นได้เต็มตามจำนวนที่เกิดขึ้นทั้งหมด
          </MessageDisplay>
          <MessageDisplay title="11. หากข้อกำหนด, เงื่อนไข เอกสารฉบับนี้เป็นโมฆะ, ไม่สมบูรณ์ ให้ข้อกำหนดที่เป็นโมฆะ,ไม่สมบูรณ์ แยกต่างหาก จากข้อกำหนดส่วน ที่สมบูรณ์ และให้ข้อกำหนด, เงื่อนไข หรือข้อตกลงส่วนที่สมบูรณ์ ใช้บังคับได้ต่อไป">
            หากข้อกำหนด, เงื่อนไข เอกสารฉบับนี้เป็นโมฆะ, ไม่สมบูรณ์,
            ขัดต่อกฎหมายหรือใช้บังคับไม่ได้ ไม่ว่าเพราะเหตุผลใดๆ Rider และ AM
            ทั้งสองฝ่ายตกลงให้ข้อกำหนด, เงื่อนไข หรือข้อตกลงที่เป็นโมฆะ,
            ไม่สมบูรณ์, ขัดต่อกฎหมาย หรือใช้บังคับไม่ได้นั้น แยกต่างหากจาก
            ข้อกำหนด, เงื่อนไข หรือข้อตกลงส่วนที่สมบูรณ์และให้ข้อกำหนด, เงื่อนไข
            หรือข้อตกลงส่วนที่สมบูรณ์ ใช้บังคับได้ต่อไป และทั้งสองฝ่าย
            ตกลงที่จะใช้ความพยายามอย่างเต็มที่และโดยสุจริต ในการร่วมกัน
            แก้ไขข้อกำหนด, เงื่อนไข หรือข้อตกลงที่เป็นโมฆะ, ไม่สมบูรณ์, ขัดต่อ
            กฎหมาย หรือใช้บังคับไม่ได้ดังกล่าวให้เป็นข้อสัญญาที่สมบูรณ์ และใช้
            บังคับได้ใกล้เคียงกัน หรือตรงตามเจตนาของทั้งสองฝ่ายต่อไป
          </MessageDisplay>
          <MessageDisplay title="12.  การที่ AM ยอมยกเว้น ให้มีผล เป็นการผ่อนผันการ ปฏิบัติหน้าที่สำหรับครั้งนั้น">
            Rider ตกลงและรับทราบว่าการที่ AM ยอมยกเว้น หรือไม่ได้ใช้สิทธิ
            ข้อใดข้อหนึ่งในเอกสารนี้ ไม่ว่าครั้งเดียว หรือหลายครั้งก็ตาม ให้มีผล
            เป็นการผ่อนผันการปฏิบัติหน้าที่สำหรับครั้งนั้น และมิให้ถือว่า AM
            ยินยอม หรือสละสิทธิตามสัญญานี้บางส่วนหรือทั้งหมดในครั้งต่อไปด้วย โดย
            Rider ยังคงมีหน้าที่ต้องปฏิบัติตามสัญญานี้ โดยเคร่งครัดทุกประการ
          </MessageDisplay>
          <MessageDisplay title="13. การบอกกล่าวใดๆเป็นหนังสือส่งทาง ไปรษณีย์ลงทะเบียน อีเมล์ การส่งข้อความ (SMS) หรือผ่านช่องทาง แอพพลิเคชั่น อื่นใด ให้ถือเป็นการบอกกล่าวที่ชอบด้วยกฎหมาย">
            Rider ตกลงและรับทราบว่าการบอกกล่าวใดๆ ตามเงื่อนไขการ
            เป็นผู้ให้บริการขนส่งตามเอกสารฉบับนี้ หากได้ทำเป็นหนังสือส่งทาง
            ไปรษณีย์ลงทะเบียน อีเมล์ การส่งข้อความ (SMS) หรือผ่านช่องทาง
            แอพพลิเคชั่นอื่นใด ให้ถือเป็นการบอกกล่าวที่ชอบด้วยกฎหมาย และ Rider
            ได้รับทราบแล้ว
          </MessageDisplay>
          <MessageDisplay title="14. เงื่อนไขการเป็นผู้ให้บริการขนส่งฉบับนี้ ให้ใช้บังคับ ตามกฎหมายไทย" />
          <MessageDisplay title="15. Rider ตกลงและรับทราบ ข้อกำหนดแจ้งการประมวล ผลข้อมูล ส่วนบุคคล (Privacy Notice) ดังมีรายละเอียด ดังต่อไปนี้">
            <MessageDisplay
              title="15.1. AM ได้เก็บรวบรวมและหรือใช้ข้อมูลส่วนบุคคลของผู้ขนส่ง (“ข้อมูลส่วนบุคคล”) ได้แก่"
              fontSize={theme.fontSize.xs}
            >
              <BulletList
                items={[
                  'รายละเอียดส่วนบุคคล เช่น คำนำหน้าชื่อ ชื่อนามสกุล วันเดือนปีเกิด เพศ ภาพถ่าย ข้อมูลเกี่ยวกับบัตรที่ออกให้โดยทางราชการ (เช่น สำเนาบัตรประจำตัวประชาชนและสำเนาทะเบียนบ้าน สำเนาใบขับขี่ พรบ. เล่มทะเบียนรถ และใบอนุญาตอื่นๆ เป็นต้น) ทะเบียนรถจักรยายนต์ ลายมือชื่อ บัญชีธนาคาร กระเป๋าเงินอิเล็กทรอนิกส์ (e-Wallet) และข้อมูลระบุตัวตนอื่นๆ',
                  'ข้อมูลการติดต่อ เช่น หมายเลขโทรศัพท์มือถือ ที่อยู่ตามทะเบียนบ้าน ที่อยู่ปัจจุบัน ที่อยู่อีเมล์ บัญชี Line และข้อมูลอื่นๆที่มีลักษณะเดียวกัน',
                  'ข้อมูลเกี่ยวกับประวัติส่วนตัวของผู้ขนส่ง เช่น ประวัติการฝึกอบรม',
                  'ข้อมูลอื่นๆ ที่จำเป็นต่อการปฏิบัติตามสัญญา เช่น ข้อมูลการติดตาม GPS รายงานการปฏิบัติงาน พฤติกรรม   การทำงาน ประกันอุบัติเหตุ ข้อมูลการถูกร้องเรียน ข้อมูล LOG การเข้าใช้งานระบบการทำงาน ตลอดจนข้อมูลทางเทคนิคอื่นๆ ที่จำเป็น รุ่นโทรศัพท์ เพื่อการบริหาร การทำงาน และการคำนวณค่าบริการขนส่งสินค้า',
                  'ข้อมูลเกี่ยวกับมุมมองและความคิดเห็นของผู้ขนส่ง เช่น การแสดงความคิดเห็น การให้ข้อติชม การร้องเรียน การให้คำแนะนำ การตอบแบบสำรวจความคิดเห็น ข้อซักถามและข้อมูลที่ท่านสมัครใจให้ในระหว่างที่มีการให้บริการตามสัญญา เป็นระยะเวลาทั้งหมด 10 (สิบ) ปี นับจากวันที่สัญญา ฉบับนี้สิ้นสุดลง โดยมีวัตถุประสงค์เพื่อตรวจสอบความเป็นตัวตน ของผู้ขนส่ง และเพื่อใช้ตามวัตถุประสงค์ตามสัญญาฉบับนี้เท่านั้น โดยไม่นำข้อมูลส่วนบุคคลดังกล่าวไปใช้เพื่อวัตถุประสงค์อื่นใดนอกจากสัญญาฉบับนี้แต่อย่างใด ทั้งนี้ หากผู้ขนส่งไม่ส่งมอบข้อมูล ส่วนบุคคลดังกล่าวแก่ AM จะทำให้การจัดทำสัญญาฉบับนี้ ไม่สมบูรณ์ อันเป็นฐานการประมวลผลเพื่อเป็นการจำเป็น เพื่อการปฏิบัติตามสัญญาและเป็นการจำเป็นเพื่อประโยชน์ โดยชอบด้วยกฎหมาย ตามมาตรา 24 (3), (5) ของพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562',
                ]}
              />
              ทั้งนี้ ผู้ขนส่งในฐานะเจ้าของข้อมูลส่วนบุคคลรับทราบว่า
              ตนเองมีสิทธิดังนี้
              <BulletList
                items={[
                  'สิทธิในการเข้าถึงและรับสำเนาข้อมูลส่วนบุคคลที่ AM ได้ทำการเก็บรวบรวมและหรือใช้ได้ ตลอดจนสิทธิในการคัดค้าน การประมวลผลข้อมูลส่วนบุคคล',
                  'เมื่อพ้นระยะเวลาทั้งหมด 10 (สิบ) ปี นับจากวันที่สัญญาฉบับนี้ สิ้นสุดลง AM จะทำการลบหรือทำลายข้อมูลส่วนบุคคล',
                  'สิทธิในการขอให้ AM ระงับการใช้ข้อมูลส่วนบุคคล หาก AM ได้ใช้ ข้อมูลส่วนบุคคลไม่เป็นไปตามวัตถุประสงค์ตามวรรคแรกข้างต้น',
                  'สิทธิในการขอแก้ไขข้อมูลส่วนบุคคลให้ถูกต้องเป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด',
                  'สิทธิในการร้องเรียน AM  หากเห็นว่าผู้ขนส่งถูกเจ้าหน้าที่หรือตัวแทน ของ AM ละเมิด (ตามรายละเอียดและช่องทางที่กำหนดไว้ใน ข้อ 15.2 นี้)',
                ]}
              />
              การใช้สิทธิข้างต้น จะต้องจัดทำเป็นลายลักษณ์อักษร และ AM จะใช้
              ความพยายามอย่างดีที่สุดที่จะดำเนินการภายในระยะเวลาอันสมควร
              และไม่เกินระยะเวลาที่กฎหมายกำหนด โดย AM จะปฏิบัติตามข้อกำหนด
              ทางกฎหมายที่เกี่ยวข้องกับสิทธิของเจ้าของข้อมูลส่วนบุคคล และ AM
              ขอสงวนสิทธิ์ในการคิดค่าบริการใดๆ ที่เกี่ยวข้องและจำเป็น
              ต่อการใช้สิทธิดังกล่าว
            </MessageDisplay>
            <MessageDisplay
              title="15.2. หากมีเหตุร้องเรียนเกี่ยวกับข้อมูลส่วนบุคคล สามารถติดต่อ ประสานงานมายังเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลได้ในช่องทางดังนี้"
              fontSize={theme.fontSize.xs}
            >
              <TextBold
                color={theme.palettes.black85}
                margin={'0px 0px 8px'}
                display={'block'}
              >
                เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล
              </TextBold>
              <TextRegular color={theme.palettes.black85}>
                เลขที่ 119 อาคารธาราสาทร ชั้น 8 ถนนสาทรใต้ แขวงทุ่งมหาเมฆ
                เขตสาทร กรุงเทพมหานคร 10120
                <br />
                Email Address:&nbsp;
                <a href="mailto:privacy@allnow.co.th">privacy@allnow.co.th</a>
              </TextRegular>
              <TextBold
                color={theme.palettes.black85}
                margin={'8px 0px 8px'}
                display={'block'}
              >
                ผู้ควบคุมข้อมูลส่วนบุคคล
              </TextBold>
              <TextRegular color={theme.palettes.black85}>
                บริษัท ออลล์ นาว แมนเนจเม้นท์ จำกัด เลขที่ 119 ชั้น 8
                อาคารธาราสาทร ถนนสาทรใต้ แขวงทุ่งมหาเมฆ เขตสาทร กรุงเทพมหานคร
                Email Address:&nbsp;
                <a href="mailto:dpc@allnow.co.th">dpc@allnow.co.th</a>
              </TextRegular>
            </MessageDisplay>
          </MessageDisplay>
          <TextRegular color={theme.palettes.black85}>
            ทั้งนี้ Rider ตกลงรับทราบและตกลงปฏิบัติตามเงื่อนไขการเป็น
            ผู้ให้บริการ ขนส่งฉบับนี้ และตกลงยอมรับถึงเงื่อนไขการให้บริการที่ AM
            อาจประกาศผ่านทางเว็บไซต์ หรือช่องทางการสื่อสารอื่นใด (หากมี)
          </TextRegular>
        </div>
      </DriverPortalLayout>
    </>
  );
};

export default NewTermsAndCondition;
